import img1b from '../../../images/knbf-skjema/liten-bat-uten-motor/1-b.webp'
import img1c from '../../../images/knbf-skjema/liten-bat-uten-motor/1-c.webp'
import img1d from '../../../images/knbf-skjema/liten-bat-uten-motor/1-d.webp'
import img1f from '../../../images/knbf-skjema/liten-bat-uten-motor/1-f.webp'
import img2b from '../../../images/knbf-skjema/liten-bat-uten-motor/2-b.webp'
import img3a from '../../../images/knbf-skjema/liten-bat-uten-motor/3-a.webp'
import img3b from '../../../images/knbf-skjema/liten-bat-uten-motor/3-b.webp'
import img3c from '../../../images/knbf-skjema/liten-bat-uten-motor/3-c.webp'
import img3d from '../../../images/knbf-skjema/liten-bat-uten-motor/3-d.webp'
import img3e from '../../../images/knbf-skjema/liten-bat-uten-motor/3-e.webp'
import img3f from '../../../images/knbf-skjema/liten-bat-uten-motor/3-f.webp'
import img4a from '../../../images/knbf-skjema/liten-bat-uten-motor/4-a.webp'
import img4b from '../../../images/knbf-skjema/liten-bat-uten-motor/4-b.webp'
import img5a from '../../../images/knbf-skjema/liten-bat-uten-motor/5-a.webp'

const litenBatUtenMotor = {
	title: 'Liten båt uten motor',
	logo: 'knbf',
	formDescription: 'Robåt, jolle eller annen, enkel åpen båt uten motor.',
	tableQuestions: [

		{header: '1. Er båten tett og fri for vann'},
		{text: 'A. På land – skrogets utside', legendIcon: 'y', modalContent: <p>Kontrollere at skroget ikke har alvorlige skader</p>},
		{text: 'B. På land – bunnplugg, lenseplugg (om dette finnes)', legendIcon: 'y', modalContent: <p>Kontrollere at
				de(n) sitter fast før sjøsetting. Pluggen kan være slitt eller sprukken. Noen har også en pakning som
				bør kontrolleres årlig. Byttes ved behov. <img src={img1b}/></p>
		},
		{text: 'C. På land – selvlensende cockpit (om dette finnes)', legendIcon: 'y', modalContent: <p>Fungerer
				avløpet? Sitter eventuelle slanger godt fast? På båter der selvlensen munner ut under vannlinjen skal
				det alltid være en stengeventil. Kan den åpnes lett, og er den tett når den er stengt?<img src={img1c}/>
			</p>
		},
		{
			text: 'D. På land – kontroller at skroggjennomføringer er tette (om slike finnes)', legendIcon: 'y', modalContent:
				<p>Skroggjennomføringer med tilkoblinger for ventiler (= kraner), slanger og selvlensere.

					På utsiden: Skrap bort bunnstoff og begroing. Kontroller at det ikke er tegn på korrosjon, sprekker,
					rust eller glipper mellom skroggjennomføringens flens og skroget. Hvis ventiler har vært stengt
					gjennom vinteren, er det risiko for at de har frosset og sprukket.

					På innsiden: Kontroller at skroggjennomføringen sitter godt fast, ikke har korrosjonsangrep og ikke
					viser tegn til lekkasje. Sjekk at slangene ikke har sprekker eller slitasje, og at håndtaket sitter
					fast og ikke er rustent. Tynne spiralforsterkede plastslanger er uegnet.

					Slanger skal, ifølge gjeldende regelverk, under eller nær vannlinjen være festet til
					skroggjennomføringen med doble slangeklemmer i rustfritt stål, montert i motsatt retning. Ventilen
					skal "beveges" slik at den enkelt kan åpnes og lukkes.<img src={img1d}/></p>
		},
		{text: 'E. På sjøen – løft på dørken',legendIcon: 'b', modalContent: <p>Kontroller at det ikke finnes vann under dørkplatene. Også under innerlineren (inne i skroget om det er dobbeltbunn). Selv en liten mengde vann som skvulper rundt kan påvirke stabiliteten. Sørg for at det er rent og tørt i kjølsvinet/motorrommet, slik at lekkasjer kan oppdages raskt.</p>},
		{text: 'F. På sjøen – kontroller at skroggjennomføringer er tette (om dette finnes)',legendIcon: 'm', modalContent:
				<p>Skroggjennomføringer med tilkoblinger for ventiler (= kraner), slanger og selvlensere. Kontroller at
					det ikke er tegn på lekkasje ved skroggjennomføringen, og at det er tørt rundt gjennomføringens
					flensmutter, ventilens gjenger og slangetilkoblinger. Ventilen skal "beveges" innimellom slik at den
					enkelt kan åpnes og lukkes.
					<img src={img1f}/></p>
		},

		{header: '2. Flytesikkerhet'},
		{text: 'A. Finnes det tilstrekkelig og fungerende flytemiddel', legendIcon: 'y', modalContent: <p>Hvis båten skulle kantre eller fylle seg med vann av en eller annen grunn, er det viktig at den fortsatt flyter på flytetankene.</p>},
		{text: 'B. Ved båt med flytetanker', legendIcon: 'y', modalContent: <p>Kontroller at de er intakte og sitter
				godt fast.<img src={img2b}/></p>
		},

		{header: '3. Sikkerhetsutstyr'},
		{text: 'A. Anker, mindre båt', legendIcon: 'y', modalContent: <p>Det finnes ulike typer anker/dregg i ulike
				størrelser og for ulike bunnforhold. Tilpass etter din båts størrelse og ankringsdybde. Kontrollere
				linens/kjettingens tilstand og at sjakler er strammet og sikret.<img src={img3a}/></p>
		},
		{text: 'B. Båtshake', legendIcon: 'm', modalContent: <p>Kontroller at kroken sitter fast og at stangen er
				intakt. Spesielt viktig for båtshaker som er teleskopiske.<img src={img3b}/></p>
		},
		{text: 'C. CE-merking/blått skilt', legendIcon: 'y', modalContent: <p>Angir blant annet maks antall personer som
				båten er godkjent for, maks last og motorstyrke.<img src={img3c}/></p>
		},
		{text: 'D. Fendre', legendIcon: 'm', modalContent: <p>Minst fire fendere er anbefalt å ha ombord (tilpasset
				båtens størrelse)<img src={img3d}/></p>
		},
		{text: 'E. Flytevest eller flyteplagg', legendIcon: 'b', modalContent: <p>Skal alltid finnes om bord for antallet personer i båten, og er ved flere tilfeller påbudt å bruke. Flytevester skal være CE-merket. Service for oppblåsbare modeller må utføres i henhold til produsentens anbefalinger/krav.  Oppblåsbare flytevester skal sjekkes årlig!<img src={img3e}/></p>},
		{text: 'F. Fortøyningstau', legendIcon: 'm', modalContent: <p>Minst fire tauverk er anbefalt å ha om bord
				(tilpasset båtens vekt, og gjerne flere lengder). Fortøyningsfjær bør finnes, og kontroller tilstanden
				til disse og bytt ved behov.<img src={img3f}/></p>
		},
		{text: 'G. Reserveåre', legendIcon: 'b', modalContent: <p>I båt med årer bør det finnes en reserveåre. Det kan uansett være smart å ha i enhver båt som et sikkerhetsutstyr ved motorstopp.</p>},
		{text: 'H. Øsekar', legendIcon: 'b', modalContent: <p>Bør være festet med karabinhake/line.</p>},

		{header: '4. Nødutstyr'},
		{text: 'A. Caps – solbeskyttelse – brillesnor (flytende)', legendIcon: 'b', modalContent: <img src={img4a}/>},
		{text: 'B. Mobiltelefon', legendIcon: 'b', modalContent: <p>I vanntett etui og helst med GPS. Husk å legge inn
				viktige telefonnummer, som til Redningsselskapet og sjøens nødnummer – 02016 eller 120.<img
					src={img4b}/></p>
		},

		{header: '5. Fremdrift'},
		{text: 'A. Årer', legendIcon: 'b', modalContent: <p>Kontrollere at de er hele, og at åregaflene sitter godt fast
				og er hele.<img src={img5a}/></p>
		},
	]
}

export default litenBatUtenMotor;